import React from "react";
import { Button } from "react-bootstrap";

const NavBarNotifications = ({ count }: { count: number }) => (
  <li className="c-navbar__nav-item c-navbar__nav-item-notification">
    <Button
      variant={""}
      as={"a"}
      className="c-btn c-btn--tertiary c-btn--sm btn-navbar-notifications"
      href={""}
    >
      <i className="far fa-bell" />
      <span className="counter notification-badge">{count}</span>
    </Button>
  </li>
);

export default NavBarNotifications;
